/**
 * @desc 历史报告
 */
import styles from './searchList.scss';
import React from 'react';
import cns from 'classnames';
import { Spin, Table } from 'antd';
import { ReportStatus } from '../../../../constants/enum';
import { ReportStatusText, RiskFraudTypeText, ReportDateTypeText, ReportTypeText } from '../../../../constants/info';
import { dateTimeFormat } from '../../../../utils/formatter';
import { downloadURI } from '../../../../utils/util';
import NoData from '../../../common/noData/NoData';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import SearchBar from '../../common/searchBar/SearchBar';
import { getHistoryReport } from '../../../../services/user';
import { downloadReport } from '../../../../services/report';

export default class Report extends TableSearch {
    constructor(props) {
        super(props);
        this.server = getHistoryReport;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchParams: {},
            loading: true,
            data: [],
            showType: 'pic'
        };
    }

    // 下载
    onDownload = (id) => {
        downloadReport({ id }).then(data => {
            downloadURI(data);
        });
    };

    // 更新，一期暂不开发
    onRefresh = (e, id) => {
        e.stopPropagation();
    };

    changeShowType = (showType) => {
        this.setState({ showType });
    };

    jointReportType = (d) => {
        return d.reportYear + '年' + ReportDateTypeText[d.reportDateType] + ReportTypeText[d.reportType];
    };

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 100
        }, {
            title: '公司简称',
            dataIndex: 'sesName'
        }, {
            title: '报告类型',
            dataIndex: 'type',
            width: 150,
            render: (v) => RiskFraudTypeText[v] + '报告'
        }, {
            title: '财报类型',
            dataIndex: 'reportYear',
            width: 220,
            render: (v, d) => this.jointReportType(d)
        }, {
            title: '报告状态',
            dataIndex: 'status',
            width: 100,
            render: (v) => <span className={v === ReportStatus.SUCCESS ? 'green-font' : 'red-font'}>{ReportStatusText[v]}</span>
        }, {
            title: '生成时间',
            dataIndex: 'createTime',
            width: 150,
            render: dateTimeFormat
        }, {
            title: '操作',
            dataIndex: 'operation',
            className: 'operation',
            width: 80,
            render: (v, d) => d.status === ReportStatus.SUCCESS ? <a href="javascript:void(0)" onClick={() => this.onDownload(d.id)}>下载</a> : '--'
        }];
    };

    render() {
        const { data, pageNum, pageSize, total, loading, showType } = this.state;

        return (
            <div>

                <SearchBar onSearch={this.onSearch} />

                <div className={styles.showType}>
                    <i title="平铺"
                       className={cns('iconfont icon-hangye', { [styles.active]: showType === 'pic' })}
                       onClick={() => this.changeShowType('pic')}> </i>
                    <i title="列表"
                       className={cns('iconfont icon-ai-list', { [styles.active]: showType === 'table' })}
                       onClick={() => this.changeShowType('table')}> </i>
                </div>

                {
                    showType === 'pic' ?
                        <div>
                            {
                                loading ?
                                    <Spin tip="数据加载中，请稍候……"/> :
                                    data.length ?
                                        <div>
                                            <ul className="clearfix">
                                                {
                                                    data.map(d => {
                                                        const isFail = d.status === ReportStatus.FAIL;
                                                        const name = d.sesName + this.jointReportType(d) + RiskFraudTypeText[d.type] + '报告';
                                                        return (
                                                            <li
                                                                key={d.id}
                                                                className={cns(styles.reportItem, isFail ? styles.fail : '')}
                                                            >
                                                                <div
                                                                    className={styles.reportItemContent}
                                                                    onClick={isFail ? undefined : () => this.onDownload(d.id)}
                                                                >
                                                                    <p className={styles.reportName}>{name}</p>
                                                                    { isFail ? <p className={styles.failTip}><i className="iconfont icon-shibai"></i> <br/> 生成失败</p> : null }
                                                                    <p className={styles.reportRefresh} onClick={(e) => this.onRefresh(e, d.id)}>更新</p>
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                            <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>
                                        </div>
                                        :
                                        <NoData />
                            }
                        </div> :
                        <Table
                            rowKey="id"
                            loading={loading}
                            pagination={false}
                            columns={this.getColumns()}
                            dataSource={data}
                            bordered
                            footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                        />
                }

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/report/index/SearchList.jsx